import { withLayout } from 'layouts';
import LessionAttendance from './lesson-attendance.container';

export default withLayout(LessionAttendance);
